/*
 * Copyright '2023' Dell Inc. or its subsidiaries. All Rights Reserved.
 */
export interface ActionTypeModel {
  type: string;
  linkAction: LinkActionType;
}

export interface LinkActionType {
  openInNewTab: boolean;
  useLocalized: boolean;
  universalLink?: { [key: string]: string };
  localizedLinks?: { [key: string]: { [key: string]: string } };
}

export enum ActionType {
  LINK = "LINK",
  NULL = "NULL",
  NONE = "NONE",
}

export interface ActionProps {
  link: string;
  newTab: boolean;
}
